/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

import { debounce } from './resizeHandler.js';

( function() {
	
	//declare all our variables here
	const navChangeBreakpoint = 959; //breakpoint for mobile screens
	const siteNavigation = document.getElementById( 'site-navigation' );
	const body = document.getElementsByTagName('body')[0];
	// Return early if the navigation doesn't exist.
	if ( ! siteNavigation ) {
		return;
	}
	//nav list li items
	const navContainer = document.querySelector('.menu-primary-navigation-container');
	const nav = document.querySelector('nav.main-navigation ul');
	// Return early if the navigation doesn't exist.
	if ( ! nav ) {
		return;
	}
	
	/*************************************
    * NAV ROLLOVER ANIMATIONS
   	*************************************/
	
	const menuItems = nav.querySelectorAll('.menu-item');

	// Mobile menu trigger (if used elsewhere).
	const button = siteNavigation.getElementsByTagName('button')[0];


	//let's set a class noncurrent_page_item to all menuItems if they dont have class current_page_item
	const hasCurrentItem = Array.from(menuItems).some(item => item.classList.contains('current_page_item'));
	if (hasCurrentItem) {
		menuItems.forEach(item => {
			if (!item.classList.contains('current_page_item')) {
				item.classList.add('noncurrent_page_item');
			}
		});
	}
	
	// Add hover effects for all menu items.
	menuItems.forEach(item => {
		// Skip items with the 'search-btn' class.
		if (item.classList.contains('search-btn')) {
			return;
		}
		
		item.addEventListener('mouseenter', () => {
			if (window.innerWidth >= navChangeBreakpoint) {
				// Add the 'off' class to all menu items except for the hovered one.
				menuItems.forEach(other => {
					if (other !== item) {
						other.classList.add('off');
					}
				});
			}
		});
		
		item.addEventListener('mouseleave', () => {
			if (window.innerWidth >= navChangeBreakpoint) {
				// Remove the 'off' class from all menu items.
				menuItems.forEach(other => {
					other.classList.remove('off');
				});
			}
		});
	});


	/*end nav hover*/	

	// SEARCH icon in top nav
	const searchLink = nav.querySelector('.search-btn a');
	const headerSearch = document.querySelector('.header-search');
	const mainEl = document.querySelector('main');
	const openLabel  = BrunswickL10n.openLabel;
	const closeLabel = BrunswickL10n.closeLabel;	

	if(searchLink && headerSearch) {
		searchLink.setAttribute('role','button');
		searchLink.setAttribute('aria-expanded','false');
		searchLink.setAttribute('aria-controls','header-search');
		headerSearch.setAttribute('aria-hidden','true');
  		if ( 'inert' in headerSearch ) headerSearch.inert = true;
		headerSearch.hidden = true;

		searchLink.setAttribute('aria-label',openLabel);
		
		searchLink.addEventListener('click', function (e) {
			e.preventDefault();
			// Check if the search field is currently expanded by inspecting the inline style.
			if (headerSearch.style.maxHeight && headerSearch.style.maxHeight !== "0px") {
				// If expanded, collapse it.
				collapseSearch();
			} else {
				// Toggle the "close-icon" class to switch icons
				searchLink.classList.toggle('close-icon');
				searchLink.setAttribute('aria-expanded', 'true');
				searchLink.setAttribute('aria-label', closeLabel);
				
				// Remove inert so panel can receive focus
				if ( 'inert' in headerSearch ) headerSearch.inert = false;
				headerSearch.removeAttribute('aria-hidden');
				headerSearch.hidden = false;

				headerSearch.style.opacity = '1';
				// If collapsed, set maxHeight to the element's scrollHeight (its full height)
				headerSearch.style.maxHeight = headerSearch.scrollHeight + "px";
				// Add active class to headerSearch and add overlay to mainEl
				headerSearch.classList.add('active');
				if (!mainEl.classList.contains('overlay-active')) {
					mainEl.classList.add('overlay-active');
				}
				// Focus the search input field after a short delay to match the transition duration.
				const searchInput = headerSearch.querySelector('input.search-field');
				if (searchInput) {
					setTimeout(() => {
						searchInput.focus();
					}, 300); // Adjust delay if needed.
				}
				//in mobile, hide the close/menu button and set the nav overflow to hidden
				button.style.opacity = '0';
				//collpase the nav container if toggled out (in mobile)
				if(siteNavigation.classList.contains('toggled')) {
					navContainer.style.maxHeight = "100px";
					//set the nav container to overflow hidden
					navContainer.style.overflow = "hidden";
				}
			}
		});

		// Prevent clicks inside headerSearch from triggering collapse
		headerSearch.addEventListener('click', function(e) {
			e.stopPropagation();
		});

		// Listen for clicks anywhere outside the headerSearch and searchLink
		document.addEventListener('click', function (e) {
			if (headerSearch.style.maxHeight && headerSearch.style.maxHeight !== "0px") {
				if (!headerSearch.contains(e.target) && !searchLink.contains(e.target)) {
					collapseSearch();
				}
			}
		});
	}

	// Function that collapses the search field with an animation
	var collapseSearch = function() {
		//run only if the search menu is actually open
		if (searchLink.getAttribute('aria-expanded') === 'true') {
			// Toggle the "close-icon" class to switch icons
			searchLink.classList.toggle('close-icon');
			//console.log('collapse search');
			// 1) Move focus off the input, onto the toggle
			searchLink.focus();
			// 2) Hide & inert the panel
			if ( 'inert' in headerSearch ) headerSearch.inert = true;
			headerSearch.setAttribute('aria-hidden', 'true');
			headerSearch.hidden = true;
			headerSearch.classList.remove('active');

			headerSearch.style.opacity = '0';
			// Start the collapse by setting maxHeight to "0px"
			headerSearch.style.maxHeight = "0px";
			// Remove the overlay class (if the nav is not toggled in mobile)
			if(!siteNavigation.classList.contains('toggled')) {
				mainEl.classList.remove('overlay-active');
			}else {
				//expand the nav container back up
				navContainer.style.maxHeight = navContainer.scrollHeight + "px";
			}
			//switch back to search icon
			searchLink.classList.remove('close-icon');
			//accessibility
			searchLink.setAttribute('aria-expanded', 'false');
			searchLink.setAttribute('aria-label', openLabel);

			//in mobile, show the close/menu button
			button.style.opacity = '1';
		
			
		}
	};
	// close on Escape key
	document.addEventListener('keydown', e => {
		if (
		  e.key === 'Escape' &&
		  searchLink.getAttribute('aria-expanded') === 'true'
		) {
		  collapseSearch();
		}
	});
	// prevent inner clicks from bubbling
	headerSearch.addEventListener('click', e => e.stopPropagation());
	//end search icon logic




	// -------------------------------
	// MOBILE menu logic
	// -------------------------------
	// Return early if the button doesn't exist.
	if ( 'undefined' === typeof button ) {
		return;
	}
	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof nav ) {
		button.style.display = 'none';
		return;
	}
	if ( ! nav.classList.contains( 'nav-menu' ) ) {
		nav.classList.add( 'nav-menu' );
	}

	//remove .revealed from the nav element in mobile
	const removeNavRevealClass = function() {
		siteNavigation.classList.remove('reveal');
	}
	//if window is less than the mobile var value, trigger on load
	if (window.innerWidth <= navChangeBreakpoint) { 
		removeNavRevealClass();
	}

	const showMobileNav = function($searchException = false) {
		//hide nav items
		toggleMobileNavOpacity('out');
		//nav is not open, let's open it
		siteNavigation.classList.add('toggled');
		//navContainer.style.opacity = '1';
		navContainer.style.maxHeight = navContainer.scrollHeight + "px";
		fadeNavItems(nav, 'in');
		if(!$searchException) {
			button.setAttribute( 'aria-expanded', 'true' );
			//change button label to "close" when menu is open;
			button.setAttribute( 'aria-label', 'Close' );
			//if overlay-active class is not attached to mainEl, add it
			if (!mainEl.classList.contains('overlay-active')) {
				mainEl.classList.add('overlay-active');
			}
		}
		
	}
	const hideMobileNav = function($searchException = false) {
		//nav is open, close things up
		siteNavigation.classList.remove('toggled');
		//navContainer.style.opacity = '0';
		if(!$searchException) {
			button.setAttribute( 'aria-expanded', 'false' );
			button.setAttribute( 'aria-label', 'Menu' );
			//remove overlay-active class from mainEl when menu is closed
			if (mainEl.classList.contains('overlay-active')) {
				mainEl.classList.remove('overlay-active');
			}
		}
		//make sure nav items are visible
		if(window.innerWidth > navChangeBreakpoint) {
			toggleMobileNavOpacity('in');
		}
	}

	function fadeNavItems(nav, mode, closeout) {
		// Get an array of nav children excluding elements with 'search-btn' or 'moving-dot'
		let fadeElements = Array.from(nav.children).filter(child =>
		  !child.classList.contains('search-btn') && !child.classList.contains('moving-dot')
		);
	  
		// For fade out, reverse the order so the last element (in original order) fades out last.
		if (mode === "out") {
		  fadeElements = fadeElements.reverse();
		}
	  
		let delay = 0;
		
		fadeElements.forEach(child => {
		  // Ensure a transition is set for opacity
		  child.style.transition = "opacity 0.5s ease";
	  
		  if (mode === "in") {
			// Prepare the element to fade in by setting its opacity to 0.
			child.style.opacity = "0";
			// Then fade in by setting opacity to 1 after a delay.
			setTimeout(() => {
			  child.style.opacity = "1";
			}, delay);
		  } else if (mode === "out") {
			// Fade the element out to opacity 0 after a delay.
			setTimeout(() => {
			  child.style.opacity = "0";
			}, delay);
		  }
	  
		  delay += 100;
		});
	  
		// If mode is 'out' and there is at least one element to fade, 
		// wait for the last element's opacity transition to complete, then call closeout.
		if (mode === "out" && fadeElements.length) {
		  // The last element in our reversed fadeElements array is the one that starts last.
		  const lastElement = fadeElements[fadeElements.length - 1];
		  lastElement.addEventListener('transitionend', function onTransitionEnd(e) {
			if (e.propertyName === "opacity") {
			  // Clean up the listener so it doesn't fire multiple times.
			  lastElement.removeEventListener('transitionend', onTransitionEnd);
			  // Call the closeout function once all transitions are done.
			  if (typeof closeout === "function") {
				hideMobileNav();
			  }
			}
		  });
		} else if (mode === "out") {
		  // If there are no elements to fade out, call closeout immediately.
		  if (typeof closeout === "function") {
			hideMobileNav();
		  }
		}
	  }
	  
	
	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener( 'click', function(e) {
		e.preventDefault();
		button.classList.toggle('is-active');
		if (body.classList.contains('nav_open')) {
			body.classList.remove("nav_open");
			body.classList.add("nav_closed");
		} else {
			body.classList.remove("nav_closed");
			body.classList.add("nav_open");
		}

		if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
			button.setAttribute( 'aria-expanded', 'false' );
		} else {
			button.setAttribute( 'aria-expanded', 'true' );
		}

		if(siteNavigation.classList.contains('toggled')) {
			fadeNavItems(nav, "out", function closeout() {
				// Add any additional cleanup logic here.
			});
		} else {
			showMobileNav();
		}
	} );

	var toggleMobileNavOpacity = function(mode) {
		// Get an array of nav children excluding elements with 'search-btn' or 'moving-dot'
		let fadeElements = Array.from(nav.children).filter(child =>
			!child.classList.contains('search-btn') && !child.classList.contains('moving-dot')
		);
		if (mode === "out") {
			fadeElements.forEach(child => {
				child.style.opacity = '0';
			});
		} else {
			fadeElements.forEach(child => {
				child.style.opacity = '1';
			});
		}
	}
	

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation. TODO, FIX — NOT WORKING RIGHT
	/*document.addEventListener( 'click', function( event ) {
		const isClickInside = siteNavigation.contains( event.target );

		if ( ! isClickInside ) {
			//hide mobile nav
			hideMobileNav();
			//collpase the search field if it is open
			collapseSearch();
		}
	} );*/



	// -------------------------------
	// DROPDOWNS logic and accessiblity
	// -------------------------------
	// Get all the link elements within the menu.
	const links = nav.getElementsByTagName( 'a' );

	// Get all the link elements with children within the menu.
	const linksWithChildren = nav.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

	// Toggle focus each time a menu link is focused or blurred.
	for ( const link of links ) {
		link.addEventListener( 'focus', toggleFocus, true );
		link.addEventListener( 'blur', toggleFocus, true );
	}

	// Toggle focus each time a menu link with children receive a touch event.
	for ( const link of linksWithChildren ) {
		link.addEventListener( 'touchstart', toggleFocus, false );
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		if ( event.type === 'focus' || event.type === 'blur' ) {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while ( ! self.classList.contains( 'nav-menu' ) ) {
				// On li elements toggle the class .focus.
				if ( 'li' === self.tagName.toLowerCase() ) {
					self.classList.toggle( 'focus' );
				}
				self = self.parentNode;
			}
		}

		if ( event.type === 'touchstart' ) {
			const menuItem = this.parentNode;
			event.preventDefault();
			for ( const link of menuItem.parentNode.children ) {
				if ( menuItem !== link ) {
					link.classList.remove( 'focus' );
				}
			}
			menuItem.classList.toggle( 'focus' );
		}
	}

	// -------------------------------
	// RESIZE logic
	// -------------------------------
	// Define a function that contains all the resize logic
	function handleResizeComplete() {
		// This code will run once the resize is complete
		removeNavRevealClass();
	
		/*if (headerSearch && headerSearch.classList.contains('active')) {
			collapseSearch();
		}
	
		hideMobileNav();
		toggleMobileNavOpacity('in');*/
	}
	// Create a debounced version of the resize logic (250ms delay)
	const debouncedResizeHandler = debounce(handleResizeComplete, 250);

	// Attach the debounced handler to the window resize event
	window.addEventListener('resize', debouncedResizeHandler);
	

}() );
